import React from 'react';

function UserControlMobile(props) {
	const { history } = props;

	history.goBack();

	return <div></div>;
}

export default UserControlMobile;
